<template>
  <v-form @submit.prevent="submit">
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Anmeldung
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <alert />
            <v-text-field
              v-model="credentials.username"
              type="text"
              label="Benutzername"
              :disabled="loading"
              @keyup.enter="submit"
            />
            <v-text-field
              v-model="credentials.password"
              type="password"
              label="Passwort"
              :disabled="loading"
              @keyup.enter="submit"
            />
            <v-checkbox
              v-model="credentials.rememberMe"
              label="Eingeloggt bleiben"
              :disabled="loading"
            />
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    :disabled="loading"
                    @click="submit"
                  >
                    Login
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    outlined
                    :to="{name: 'login-tenant-selection'}"
                  >
                    Zur Unternehmensanmeldung
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="isLoggedIn">
                <v-col>
                  <v-btn
                    color="primary"
                    block
                    outlined
                    :to="{name: 'index'}"
                  >
                    Weiter als {{ userDisplayName }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Alert from '../Alert'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    'alert': Alert
  },
  data () {
    return {
      credentials: {
        username: '',
        password: '',
        rememberMe: false
      },
      error: '',
      loading: false,
    }
  },
  computed: {
    doAutoLogin () {
      return !!this.$route.query.auto_login
    },
    ...mapGetters(['isLoggedIn', 'userDisplayName', 'loginProbePromise'])
  },
  watch: {
    loginProbePromise: {
      async handler (v) {
        await v
        if (this.doAutoLogin && this.isLoggedIn) {
          this.$router.push({name: 'index'})
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["login", "pushAlert", "probeLogin"]),
    async submit () {
      this.loading = true
      try {
        const credentials = {
          username: this.credentials.username,
          password: this.credentials.password,
          rememberMe: this.credentials.rememberMe,
          successRedirect: (
            this.$route.query.next ? {path: this.$route.query.next} : {name: "index"})
        }
        const result = await this.login(credentials)
        if (!result.success) {
          let message
          if (result.invalid_credentials) {
            message = "Benutzername oder Kennwort ungültig."
          } else {
            message = "Unbekannter Fehler beim Anmelden."
          }
          this.pushAlert({type: "alert alert-danger", message})
        }
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/*
.form-login {
  outline: 0;
  padding: 120px 0 10px 0;
  box-shadow: 0 0 0 0 transparent;
  text-decoration: none;
}

.form-control {
  outline: 0;
  box-shadow: 0 0 0 0 transparent;
  text-decoration: none;
  &:first-child {
    margin-bottom: -1px;
  }
  &:hover, &:active {
    border: 1px solid #ced4da;
  }
}

.login {
  margin: 10px 0 0 0;
  width: 100%;
}
*/
</style>
